var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelegate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill Icons / Delegate "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 919 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95588 6.35293C5.95588 4.9641 7.08176 3.83823 8.47059 3.83823H9.52941C10.9182 3.83823 12.0441 4.9641 12.0441 6.35293C12.0441 6.86461 11.6293 7.2794 11.1176 7.2794H6.88235C6.37068 7.2794 5.95588 6.86461 5.95588 6.35293ZM8.47059 4.63234C7.52033 4.63234 6.75 5.40268 6.75 6.35293C6.75 6.42603 6.80926 6.48529 6.88235 6.48529H11.1176C11.1907 6.48529 11.25 6.42603 11.25 6.35293C11.25 5.40268 10.4797 4.63234 9.52941 4.63234H8.47059Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 338 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.926472C8.34213 0.926472 7.80882 1.45978 7.80882 2.11765C7.80882 2.77552 8.34213 3.30883 9 3.30883C9.65787 3.30883 10.1912 2.77552 10.1912 2.11765C10.1912 1.45978 9.65787 0.926472 9 0.926472ZM7.01471 2.11765C7.01471 1.0212 7.90355 0.132355 9 0.132355C10.0964 0.132355 10.9853 1.0212 10.9853 2.11765C10.9853 3.2141 10.0964 4.10294 9 4.10294C7.90355 4.10294 7.01471 3.2141 7.01471 2.11765Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 339 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11765 14.6912C1.45978 14.6912 0.926472 15.2245 0.926472 15.8824C0.926472 16.5402 1.45978 17.0735 2.11765 17.0735C2.77552 17.0735 3.30883 16.5402 3.30883 15.8824C3.30883 15.2245 2.77552 14.6912 2.11765 14.6912ZM0.132355 15.8824C0.132355 14.7859 1.0212 13.8971 2.11765 13.8971C3.2141 13.8971 4.10294 14.7859 4.10294 15.8824C4.10294 16.9788 3.2141 17.8677 2.11765 17.8677C1.0212 17.8677 0.132355 16.9788 0.132355 15.8824Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 340 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.6912C8.34213 14.6912 7.80882 15.2245 7.80882 15.8824C7.80882 16.5402 8.34213 17.0735 9 17.0735C9.65787 17.0735 10.1912 16.5402 10.1912 15.8824C10.1912 15.2245 9.65787 14.6912 9 14.6912ZM7.01471 15.8824C7.01471 14.7859 7.90355 13.8971 9 13.8971C10.0964 13.8971 10.9853 14.7859 10.9853 15.8824C10.9853 16.9788 10.0964 17.8677 9 17.8677C7.90355 17.8677 7.01471 16.9788 7.01471 15.8824Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 341 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8824 14.6912C15.2245 14.6912 14.6912 15.2245 14.6912 15.8824C14.6912 16.5402 15.2245 17.0735 15.8824 17.0735C16.5402 17.0735 17.0735 16.5402 17.0735 15.8824C17.0735 15.2245 16.5402 14.6912 15.8824 14.6912ZM13.8971 15.8824C13.8971 14.7859 14.7859 13.8971 15.8824 13.8971C16.9788 13.8971 17.8676 14.7859 17.8676 15.8824C17.8676 16.9788 16.9788 17.8677 15.8824 17.8677C14.7859 17.8677 13.8971 16.9788 13.8971 15.8824Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 686 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39706 10.9853V12.7059H8.60294V10.9853H3.70588C3.04801 10.9853 2.51471 11.5186 2.51471 12.1765V12.7059H1.72059V12.1765C1.72059 11.08 2.60944 10.1912 3.70588 10.1912H8.60294V8.47058H9.39706V10.1912H14.5588C15.6553 10.1912 16.5441 11.08 16.5441 12.1765V12.7059H15.75V12.1765C15.75 11.5186 15.2167 10.9853 14.5588 10.9853H9.39706Z",
    fill: "inherit"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegate);
export default __webpack_public_path__ + "static/media/Delegate.b1b52cf241f4b240f086d46af260c4c1.svg";
export { ForwardRef as ReactComponent };